import React, { useState } from 'react'

import Accordion from 'components/layout/accordion'

export type IHierarchyItem = {
  hierarchyId: number
  elementId: number
  parentId: number
  name: string
  isRoot?: boolean
  subHierarchy: IHierarchyItem[]
}

interface IState {
  id: string | null
}

interface IProps {
  selected: number | null
  hierarchy: IHierarchyItem[]
  onChange: (id: string) => void
}

const SelectAccordion: React.FC<IProps> = ({ selected, hierarchy, onChange }) => {
  const [state, setState] = useState<IState>({
    id: null,
  })

  const handleSet = (id: string | null) => {
    if (id && id !== state.id) {
      setState({ ...state, id })
      onChange(id)
    }
  }

  const renderChildren = (children: IHierarchyItem[]) => {
    return children.map((child: IHierarchyItem) => {
      return (
        <Accordion
          key={child.hierarchyId}
          select={child.isRoot}
          subselect={!child.isRoot}
          heading={child.name}
          id={String(child.hierarchyId)}
          onChange={handleSet}
          isSelected={selected === child.hierarchyId}
        >
          {child.subHierarchy.length ? (
            renderChildren(child.subHierarchy)
          ) : (
            <span className="text-13 tracking-0.1 text-black">Keine weitere Auswahl verfügbar</span>
          )}
        </Accordion>
      )
    })
  }

  return <>{renderChildren(hierarchy)}</>
}

export default SelectAccordion
